import { post } from "@/services/http/platformServer";

export interface OrderAllLog {
    id: number;
    /**
     * 日志内容
     */
    content: string;
    /**
     * 日志类型
     */
    logType: LogType;
    /**
     * 操作类型
     */
    operationType: string;
    /**
     * 操作类型中文描述
     */
    operationTypeDesc: string;
    /**
     * 订单ID
     */
    orderId: number;
    /**
     * 订单编号(如果是拆分子订单的日志记录，这个则是父订单的订单编号)
     */
    orderOriginalId: string;
    /**
     * 店铺ID
     */
    shopId: number;
    /**
     * 拆分子订单的订单编号
     */
    splitChildOrderOriginalId?: string;
    /**
     * 操作时间
     */
    time: string;
    /**
     * 操作人
     */
    username: string;
}

export enum OrderOtherLogType {
    AUTO_MERGE = "AUTO_MERGE",
    MANUAL_MERGE = "MANUAL_MERGE",
    MANUAL_CANCEL_MERGE = "MANUAL_CANCEL_MERGE",
    AUTO_CANCEL_MERGE = "AUTO_CANCEL_MERGE",
    AUTO_SPLIT = "AUTO_SPLIT",
    MANUAL_SPLIT = "MANUAL_SPLIT",
    MANUAL_CANCEL_SPLIT = "MANUAL_CANCEL_SPLIT",
    CREATE_ABNORMAL_RECORD = "CREATE_ABNORMAL_RECORD",
    AUTO_DELETE_ABNORMAL_RECORD = "AUTO_DELETE_ABNORMAL_RECORD",
    MANUAL_DELETE_ABNORMAL_RECORD = "MANUAL_DELETE_ABNORMAL_RECORD",
    SHIPPER_NAME = "SHIPPER_NAME",
    HOLD_ORDER = "HOLD_ORDER",
    RESTORE_HOLDING_ORDER = "RESTORE_HOLDING_ORDER",
    SET_HAS_LOGISTCS_INFO = "SET_HAS_LOGISTCS_INFO",
    OUTBOUND_JD_DROPSHIP_ORDER = "OUTBOUND_JD_DROPSHIP_ORDER",
}

export enum LogType {
    WAYBILL = "WAYBILL",
    PACKING_LIST = "PACKING_LIST",
    SHIP = "SHIP",
    WAYBILL_NO = "WAYBILL_NO",
    SELLER_REMARKS = "SELLER_REMARKS",
    CONSIGNEE = "CONSIGNEE",
    ORDER_ITEM = "ORDER_ITEM",
    OTHER = "OTHER",
    DROP_SHIPPING = "DROP_SHIPPING",
    ALL = "ALL",
}

export const LogTypeNameMapping = {
    [LogType.ALL]: "全部",
    [LogType.CONSIGNEE]: "收货人信息",
    [LogType.ORDER_ITEM]: "商品项",
    [LogType.PACKING_LIST]: "发货单",
    [LogType.SELLER_REMARKS]: "备注",
    [LogType.SHIP]: "发货",
    [LogType.WAYBILL]: "快递单",
    [LogType.WAYBILL_NO]: "运单号",
    [LogType.OTHER]: "其他",
    [LogType.DROP_SHIPPING]: "代发",
};

/** ----------------------------快递单日志--------------------------- */

export enum WaybillOperationType {
    PRINT = "PRINT", // 打印机打印
    SET_TO_PRINTED = "SET_TO_PRINTED", // 手工设置为已打印
    SET_TO_UNPRINTED = "SET_TO_UNPRINTED", // 手工设置为未打印
    REPRINT = "REPRINT", // 重打电子面单
    CHANGED_WHEN_MERGE = "CHANGED_WHEN_MERGE", // 手工合并订单时改为其他单号
    GENERATE_WAYBILL_NO_ONLY = "GENERATE_WAYBILL_NO_ONLY", // 仅获取电子面单不打印
    SCAN_PRINT = "SCAN_PRINT", // 扫描打印
    SCAN_REPRINT = "SCAN_REPRINT", // 扫描重打
    REPRINT_SNAPSHOT = "REPRINT_SNAPSHOT", // 底单重打
    SCAN_PURCHASING_LABEL_PRINT = "SCAN_PURCHASING_LABEL_PRINT", // 扫描拿货标签打印
    PRINT_SPLIT = "PRINT_SPLIT", // 打印机打印（拆单打印）
    REPRINT_SPLIT = "REPRINT_SPLIT", // 重打电子面单（拆单打印）
}

export const WaybillOperationTypeNameMapping = {
    [WaybillOperationType.PRINT]: "打印机打印",
    [WaybillOperationType.SET_TO_PRINTED]: "手工设置为已打印",
    [WaybillOperationType.SET_TO_UNPRINTED]: "手工设置为未打印",
    [WaybillOperationType.REPRINT]: "重打电子面单",
    [WaybillOperationType.GENERATE_WAYBILL_NO_ONLY]: "仅获取电子面单不打印",
    [WaybillOperationType.SCAN_PRINT]: "扫描打印",
    [WaybillOperationType.SCAN_REPRINT]: "扫描重打",
    [WaybillOperationType.REPRINT_SNAPSHOT]: "底单重打",
    [WaybillOperationType.SCAN_PURCHASING_LABEL_PRINT]: "扫描拿货标签打印",
    [WaybillOperationType.PRINT_SPLIT]: "打印机打印（拆单打印）",
    [WaybillOperationType.REPRINT_SPLIT]: "重打电子面单（拆单打印）",
    [WaybillOperationType.CHANGED_WHEN_MERGE]: "手工合并订单时改为其他单号",
};

/** ----------------------------发货单日志 / 商品标签日志--------------------------- */

export enum PackingListOrderItemLabelOperationType {
    PRINT = "PRINT", // 打印机打印
    SET_TO_PRINTED = "SET_TO_PRINTED", // 手工设置为已打印
    SET_TO_UNPRINTED = "SET_TO_UNPRINTED", // 手工设置为未打印
}

export const PackingListOperationTypeNameMapping = {
    [PackingListOrderItemLabelOperationType.PRINT]: "打印机打印",
    [PackingListOrderItemLabelOperationType.SET_TO_PRINTED]: "手工设置为已打印",
    [PackingListOrderItemLabelOperationType.SET_TO_UNPRINTED]: "手工设置为未打印",
};

/** ----------------------------发货日志--------------------------- */
export enum ShipOperationType {
    SHIP_OFFLINE = "SHIP_OFFLINE", // 自己联系物流发货
    SHIP_ONLINE = "SHIP_ONLINE", // 在线发货
    SHIP_VIRTUAL = "SHIP_VIRTUAL", // 无需物流发货
    RESHIP = "RESHIP", // 重新发货
    UPDATE_MAIN_WAYBILL_NO_AND_RESHIP = "UPDATE_MAIN_WAYBILL_NO_AND_RESHIP",
    PRE_SHIP = "PRE_SHIP", // 预发货
    CANCEL_PRE_SHIP = "CANCEL_PRE_SHIP", // 取消预发货
    PRE_SHIP_AUTO_SHIP_FAILED = "PRE_SHIP_AUTO_SHIP_FAILED", // 预发货自动发货时失败
    CANCEL_SHIP = "CANCEL_SHIP", // 拼多多代发取消回传单号
    SHIP_FAIL = "SHIP_FAIL", // 发货失败
    LOGISTICS_REISSUE = "LOGISTICS_REISSUE", // 补发
    LOGISTICS_REISSUE_FAIL = "LOGISTICS_REISSUE_FAIL", // 补发失败
}

export const ShipOperationTypeNameMapping = {
    [ShipOperationType.SHIP_OFFLINE]: "自己联系物流发货",
    [ShipOperationType.SHIP_ONLINE]: "在线发货",
    [ShipOperationType.SHIP_VIRTUAL]: "无需物流发货",
    [ShipOperationType.RESHIP]: "修改单号(重新发货)",
    [ShipOperationType.UPDATE_MAIN_WAYBILL_NO_AND_RESHIP]: "更新主运单号时自动调用重新发货接口",
    [ShipOperationType.PRE_SHIP]: "预发货",
    [ShipOperationType.CANCEL_PRE_SHIP]: "取消预发货",
    [ShipOperationType.PRE_SHIP_AUTO_SHIP_FAILED]: "预发货自动发货时失败",
    [ShipOperationType.CANCEL_SHIP]: "拼多多代发取消回传单号",
    [ShipOperationType.SHIP_FAIL]: "发货失败",
    [ShipOperationType.LOGISTICS_REISSUE]: "补发",
    [ShipOperationType.LOGISTICS_REISSUE_FAIL]: "补发失败",
};

/** ----------------------------运单号日志--------------------------- */
export enum WaybillNoOperationType {
    UPDATE = "UPDATE", // 保存运单号
    DELETE = "DELETE", // 删除运单号
    CANCEL = "CANCEL", // 回收电子面单号
    DELETE_EWAYBILL = "DELETE_EWAYBILL", // 删除电子面单号
    SYSTEM_CANCEL = "SYSTEM_CANCEL", //  系统回收电子面单号
    SYSTEM_DELETE = "SYSTEM_DELETE", //  系统删除电子面单号
    CONSIGNEE_CHANGED = "CONSIGNEE_CHANGED", // 收货人地址变更
}

export const WaybillNoOperationTypeNameMapping = {
    [WaybillNoOperationType.UPDATE]: "保存运单号",
    [WaybillNoOperationType.DELETE]: "删除运单号",
    [WaybillNoOperationType.CANCEL]: "回收电子面单号",
    [WaybillNoOperationType.DELETE_EWAYBILL]: "删除电子面单号",
    [WaybillNoOperationType.SYSTEM_CANCEL]: "系统回收电子面单号",
    [WaybillNoOperationType.SYSTEM_DELETE]: "系统删除电子面单号",
    [WaybillNoOperationType.CONSIGNEE_CHANGED]: "收货人地址变更",
};

/** ----------------------------收货人日志--------------------------- */

export enum ConsigneeOperationType {
    SELLER = "SELLER", // 卖家手工修改
    BUYER = "BUYER", // 买家自助修改
    DECRYPT = "DECRYPT", // 解密查看收货人明文信息
    DECRYPT_BY_PLATFORM = "DECRYPT_BY_PLATFORM", // 卖家解密收货人明文信息（通过平台前端接口或网关解密，明文数据不经过发货易）
}

export const ConsigneeOperationTypeNameMapping = {
    [ConsigneeOperationType.SELLER]: "卖家手工修改",
    [ConsigneeOperationType.BUYER]: "买家自助修改",
    [ConsigneeOperationType.DECRYPT]: "解密查看收货人明文信息",
    [ConsigneeOperationType.DECRYPT_BY_PLATFORM]: "解密查看收货人明文信息(平台提供)",
};

/** ----------------------------其他日志--------------------------- */

export enum OtherOperationType {
    AUTO_MERGE = "AUTO_MERGE", // 自动合并
    MANUAL_MERGE = "MANUAL_MERGE", // 手工合并
    MANUAL_CANCEL_MERGE = "MANUAL_CANCEL_MERGE", // 手工取消合并
    AUTO_CANCEL_MERGE = "AUTO_CANCEL_MERGE", // 自动取消合并
    AUTO_SPLIT = "AUTO_SPLIT", // 自动拆分
    MANUAL_SPLIT = "MANUAL_SPLIT", // 手工拆分
    MANUAL_CANCEL_SPLIT = "MANUAL_CANCEL_SPLIT", // 手工取消拆分
    CREATE_ABNORMAL_RECORD = "CREATE_ABNORMAL_RECORD", // 创建异常记录
    AUTO_DELETE_ABNORMAL_RECORD = "AUTO_DELETE_ABNORMAL_RECORD", // 自动删除异常记录
    MANUAL_DELETE_ABNORMAL_RECORD = "MANUAL_DELETE_ABNORMAL_RECORD", // 手工删除异常记录
    ASSOCIATE_SHIPPER_INFO = "ASSOCIATE_SHIPPER_INFO", // 设置发货人
    PRINT_QUALITY_INSPECTION_CODE = "PRINT_QUALITY_INSPECTION_CODE", // 打印质检码
    HOLD_ORDER = "HOLD_ORDER",
    RESTORE_HOLDING_ORDER = "RESTORE_HOLDING_ORDER",
    SET_HAS_LOGISTCS_INFO = "SET_HAS_LOGISTCS_INFO",
    OUTBOUND_JD_DROPSHIP_ORDER = "OUTBOUND_JD_DROPSHIP_ORDER",
}

export const OtherOperationTypeNameMapping = {
    [OtherOperationType.AUTO_MERGE]: "自动合并",
    [OtherOperationType.MANUAL_MERGE]: "手工合并",
    [OtherOperationType.MANUAL_CANCEL_MERGE]: "手工取消合并",
    [OtherOperationType.AUTO_CANCEL_MERGE]: "自动取消合并",
    [OtherOperationType.AUTO_SPLIT]: "自动拆分",
    [OtherOperationType.MANUAL_SPLIT]: "手工拆分",
    [OtherOperationType.MANUAL_CANCEL_SPLIT]: "手工取消拆分",
    [OtherOperationType.CREATE_ABNORMAL_RECORD]: "创建异常记录",
    [OtherOperationType.AUTO_DELETE_ABNORMAL_RECORD]: "自动删除异常记录",
    [OtherOperationType.MANUAL_DELETE_ABNORMAL_RECORD]: "手工删除异常记录",
    [OtherOperationType.ASSOCIATE_SHIPPER_INFO]: "设置发货人",
    [OtherOperationType.PRINT_QUALITY_INSPECTION_CODE]: "打印质检码",
    [OtherOperationType.HOLD_ORDER]: "挂起订单",
    [OtherOperationType.RESTORE_HOLDING_ORDER]: "取消挂起",
    [OrderOtherLogType.SET_HAS_LOGISTCS_INFO]: "设为为已有物流信息",
    [OrderOtherLogType.OUTBOUND_JD_DROPSHIP_ORDER]: "订单出库",
};

/** ----------------------------代发日志--------------------------- */
export enum DropShipOperationType {
    MANUAL_PUSH_ORDER = "MANUAL_PUSH_ORDER", // 手工推送订单
    AUTO_PUSH_ORDER = "AUTO_PUSH_ORDER", // 系统自动推送订单
    CANCEL_ORDER = "CANCEL_ORDER", // 取消推单
    AUTO_PUSH_ORDER_FAILED = "AUTO_PUSH_ORDER_FAILED", // 系统自动推送订单失败
}

export const DropShipOperationTypeNameMapping = {
    [DropShipOperationType.MANUAL_PUSH_ORDER]: "手工推送订单",
    [DropShipOperationType.AUTO_PUSH_ORDER]: "系统自动推送订单",
    [DropShipOperationType.CANCEL_ORDER]: "取消推单",
    [DropShipOperationType.AUTO_PUSH_ORDER_FAILED]: "系统自动推送订单失败",
};

export interface GetOrderLogListParams {
    logType: LogType;
    /**
     * 操作时间-起始
     */
    operationTimeFrom: string;
    /**
     * 操作时间-结束
     */
    operationTimeTo: string;
    /**
     * 操作类型
     */
    operationType?:
        | WaybillOperationType
        | PackingListOrderItemLabelOperationType
        | ShipOperationType
        | WaybillNoOperationType
        | ConsigneeOperationType
        | OtherOperationType
        | DropShipOperationType;
    /**
     * 订单编号
     */
    orderOriginalId?: string;
    /**
     * 页码
     */
    pageNo: number;
    /**
     * 页数
     */
    pageSize: number;
    /**
     * 店铺ID
     */
    shopId: number;
    /**
     * 操作人
     */
    username?: string;
}

/**
 * PagedResult«OrderLogDto»
 */
interface GetOrderLogListResponse {
    items: OrderLogDto[];
    limit: number;
    offset: number;
    pageNo: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
}

/**
 * 订单操作日志
 *
 * OrderLogDto
 */
export interface OrderLogDto {
    /**
     * 日志内容
     */
    content: string;
    /**
     * 日志类型
     */
    logType: LogType;
    /**
     * 操作类型
     */
    operationType: null | string;
    /**
     * 操作类型中文描述
     */
    operationTypeDesc: null | string;
    /**
     * 订单ID
     */
    orderId: number | null;
    /**
     * 订单编号
     */
    orderOriginalId: null | string;
    /**
     * 店铺ID
     */
    shopId: number | null;
    /**
     * 操作时间
     */
    time: null | string;
    /**
     * 操作人
     */
    username: null | string;
}

export function getOrderLogList(params: GetOrderLogListParams) {
    return post<GetOrderLogListResponse>(params.shopId, `/order/log/list`, params);
}
